<template>
<div class="ChooseCertificateViewMode">
  <div class="container-fluid">
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point6Perc">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc font-styles">
            Preview Certificate
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer">
              <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-Top-3Perc float-right" alt="close-icon" @click="closeOverlay">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left lesson-font-styles orange-text-color bottom-border padding-bottom-2Perc">
            <b>Certificate Holder Name:</b> {{getUserObj.FirstName + ' ' + getUserObj.LastName}}
          </div>    
        </div>
        <div class="row vertical-align margin-bottom-2Perc margin-auto padding-top-bottom-1Perc">
          <div class="col-md-2 col-lg-2"></div>  
          <div class="col-md-4 col-lg-4 cursor-pointer" :class="{'opacity-point-5' : !isImageUrlPresent}" @click="selectMode($event, 1)">
            <p class="options-font-styles font-weight-bold">Image Format</p>
            <p><img :src="iconImage" class="img-width-height"></p>
          </div>
          <div class="col-md-4 col-lg-4 cursor-pointer" :class="{'opacity-point-5' : !isPDFUrlPresent}" @click="selectMode($event, 2)">
            <p class="options-font-styles font-weight-bold">PDF Format</p>
            <img :src="iconpdf" class="pdf-width-height">
          </div>
          <div class="col-md-2 col-lg-2"></div> 
        </div>
        <div class="row margin-bottom-2Perc">
          <div class="col-md-5 col-lg-5"></div>  
          <div class="col-md-2 col-lg-2">
            <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="closeOverlay">Done</button>
          </div>  
          <div class="col-md-5 col-lg-5"></div>
        </div>
        <div class="row"></div>
        <view-image-certificate-overlay v-if="selectedMode === 1" :userObj="getUserObj" @closeOverlay="ClosePopUp"></view-image-certificate-overlay>
        <view-pdf-certificate-overlay v-if="selectedMode === 2" :userObj="getUserObj" @closeOverlay="ClosePopUp"></view-pdf-certificate-overlay>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import iconImage from '../assets/images/iconimage.svg'
import iconpdf from '../assets/images/iconpdf.svg'
import ViewImageCertificateOverlay from '@/components/ViewImageCertificateOverlay'
import ViewPDFCertificateOverlay from '@/components/ViewPDFCertificateOverlay'
export default {
  name: 'ChooseCertificateViewMode',
  props: ['userObj'],
  created: function () {},
  data: function () {
    return {
      selectedMode: -1,
      iconImage: iconImage,
      iconpdf: iconpdf
    }
  },
  methods: {
    selectMode: function ($event, selectedFormat) {
      switch (selectedFormat) {
        case 1:
          if (this.isImageUrlPresent) {
            this.selectedMode = selectedFormat
          }
          break
        case 2:
          if (this.isPDFUrlPresent) {
            this.selectedMode = selectedFormat
          }
          break
      }
    },
    closeOverlay: function (event) {
      this.$emit('closeOverlay', false)
    },
    ClosePopUp (value) {
      this.selectedMode = -1
    }
  },
  components: {
    'view-image-certificate-overlay': ViewImageCertificateOverlay,
    'view-pdf-certificate-overlay': ViewPDFCertificateOverlay
  },
  computed: {
    getUserObj: {
      get: function () {
        return this.userObj
      }
    },
    getPDFFileURL: {
      get: function () {
        return this.getUserObj.UserCertificate.CertificatePDFUrl
      }
    },
    getImageFileURL: {
      get: function () {
        return this.getUserObj.UserCertificate.CertificateImageUrl
      }
    },
    isImageUrlPresent: {
      get: function () {
        return this.getImageFileURL !== undefined && this.getImageFileURL !== 'undefined' && this.getImageFileURL !== null && this.getImageFileURL !== 'null' && this.getImageFileURL !== ''
      }
    },
    isPDFUrlPresent: {
      get: function () {
        return this.getPDFFileURL !== undefined && this.getPDFFileURL !== 'undefined' && this.getPDFFileURL !== null && this.getPDFFileURL !== 'null' && this.getPDFFileURL !== ''
      }
    }
  }
}
</script>

<style scoped>
.opacity-point-5 {
  opacity: 0.1;
  cursor:not-allowed !important;
}
.img-width-height {
  width: 150px;
  height: 125px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.pdf-width-height {
  width: 150px;
  height: 125px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.orange-text-color {
  color: #f39c12 !important;
}
.ViewDocumentElementOverlay {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2% !important;
}
.padding-bottom-2Perc
{
	padding-bottom: 1.5% !important;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
/* .close-img-width-height {
  width: 35%;
  height: 2%;
} */
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000 !important;
}
.red-border{
  border:1px solid red;
}
.align-center {
    margin: auto;
    /* width: 50%; */
    /* border: 3px solid green; */
    /* padding: 10px; */
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.padding-left-4Point4Perc {
  padding-left: 4.4%;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.font-styles {
  font-size: 12px;
  color: #34495e;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.lesson-font-styles {
  font-size: 14px;
  color: #34495e;
}
.options-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
    margin-left:1.6%;
}
.backgroung-color-grey{
  background:grey;
}
.margin-auto{
  margin:auto;
}
.padding-top-bottom-1Perc{
  padding-top:1%;
  padding-bottom: 1%;
}
.pdf-bottom-border{
border-bottom: 1px solid black;
}
.width-80Perc{
  width:80%;
}
.margin-auto{
  margin:auto;
}
.border-red {
  border: 1px solid red;
}
.margin-bottom-1Point5Perc {
  margin-bottom: 1.5%
}
.margin-bottom-1Perc {
  margin-bottom:1%;
}
.margin-bottom-0Point5Perc {
  margin-bottom:0.5%;
}
</style>


// WEBPACK FOOTER //
// src/components/ChooseCertificateViewMode.vue